import Axios from "axios";
import {
    SET_SALES_EMPLOYEE_TARGET_LIST,
    UNSET_SALES_EMPLOYEE_TARGET_LIST,
} from "@/store/mutation-types";
import { saveUpdateSalesEmployeeTarget, getSalesEmployeeTargetList } from "@/store/api";

const state = {
    getSalesEmployeeTargetList: [],
    editingSalesEmployeeTarget: null,
};

const getters = {
    getSalesEmployeeTargetList(state) {
        return state.getSalesEmployeeTargetList;
    },
    getEditingSalesEmployeeTarget(state) {
        return state.editingSalesEmployeeTarget;
    }
};

const mutations = {
    [SET_SALES_EMPLOYEE_TARGET_LIST](state, data) {
        state.getSalesEmployeeTargetList = data;
    },
    [UNSET_SALES_EMPLOYEE_TARGET_LIST](state) {
        state.getSalesEmployeeTargetList = [];
    },
    seteditingSalesEmployeeTarget(state, data) {
        state.editingSalesEmployeeTarget = data;
    }
};

const actions = {
    saveUpdateSalesEmployeeTarget({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesEmployeeTarget, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesEmployeeTargetList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesEmployeeTargetList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_EMPLOYEE_TARGET_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_EMPLOYEE_TARGET_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleEmployeeTargetById({ commit }, data) {
        const getSaleEmployeeTargetByIdApi = `${getSalesEmployeeTargetList}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleEmployeeTargetByIdApi)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    commit("UNSET_SALES_EMPLOYEE_TARGET_LIST");
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
